export default function NumpyUfunc_FindingGCD() {
  return <div>NumpyUfunc_FindingGCD Component</div>;
}
